var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { MultiSelect } from "../Forms";
import { t, Translate } from "../I18N";
import { SidePanel } from "../Layout";
import { Icon } from "../UI";
import React from 'react';





















export const FiltersSidePanel = ({
  open,
  hideFilters,
  reset,
  states,
  templates
}) => /*#__PURE__*/
_jsx(SidePanel, { className: "suggestions-filter-sidepanel", open: open }, void 0, /*#__PURE__*/
_jsx("div", { className: "sidepanel-body" }, void 0, /*#__PURE__*/
_jsx("div", { className: "sidepanel-title" }, void 0, /*#__PURE__*/
_jsx("div", {}, void 0, t('System', 'Filters configuration')), /*#__PURE__*/
_jsx("div", { className: "filter-buttons" }, void 0, /*#__PURE__*/
_jsx("button", {
  type: "button",
  className: "closeSidepanel",
  onClick: hideFilters,
  "aria-label": "Close side panel" }, void 0, /*#__PURE__*/

_jsx(Icon, { icon: "times" })
)
)
), /*#__PURE__*/
_jsx("div", { className: "suggestion-filter-options" }, void 0, /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Status"), /*#__PURE__*/
_jsx(MultiSelect, {
  options: states.options,
  value: states.selected,
  optionsLabel: "label",
  optionsValue: "key",
  optionsToShow: 20,
  onChange: states.setSelection,
  hideSearch: true,
  showAll: true }
)
), /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Templates"), /*#__PURE__*/
_jsx(MultiSelect, {
  options: templates.options,
  value: templates.selected,
  optionsLabel: "label",
  optionsValue: "key",
  optionsToShow: 20,
  onChange: templates.setSelection,
  hideSearch: true,
  showAll: true }
)
)
)
), /*#__PURE__*/
_jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
_jsx("button", { type: "button", className: "btn btn-default clear-suggestions-filters", onClick: reset }, void 0, /*#__PURE__*/
_jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Clear Filters")
)
)
)
);